module.exports = __webpack_public_path__ + "static/media/mail.539687c8.png";